// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"6c9d0195","411":"124f9252","714":"124f9252","726":"124f9252","857":"124f9252"}[chunkId] + ".chunk.css";
};